/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as TermsRouteImport } from "./routes/terms"
import { Route as SignupRouteImport } from "./routes/signup"
import { Route as SettingsRouteImport } from "./routes/settings"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as DashboardRouteImport } from "./routes/dashboard"
import { Route as CoursesRouteImport } from "./routes/courses"
import { Route as CookiesRouteImport } from "./routes/cookies"
import { Route as AttendanceRecordRouteImport } from "./routes/attendance-record"
import { Route as AdminRouteImport } from "./routes/admin"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AdminIndexRouteImport } from "./routes/admin.index"
import { Route as AdminStudentsRouteImport } from "./routes/admin.students"
import { Route as AdminSchoolTypeRouteImport } from "./routes/admin.school-type"
import { Route as AdminReportsRouteImport } from "./routes/admin.reports"
import { Route as AdminPupilAttendanceRouteImport } from "./routes/admin.pupil-attendance"
import { Route as AdminOnboardingRouteImport } from "./routes/admin.onboarding"
import { Route as AdminMapRouteImport } from "./routes/admin.map"
import { Route as AdminLgaRouteImport } from "./routes/admin.lga"
import { Route as AdminFlaggedRouteImport } from "./routes/admin.flagged"
import { Route as AdminCoursesRouteImport } from "./routes/admin.courses"
import { Route as AdminCalendarRouteImport } from "./routes/admin.calendar"
import { Route as AdminAssistantRouteImport } from "./routes/admin.assistant"
import { Route as AdminAssignRouteImport } from "./routes/admin.assign"
import { Route as AdminAnalyticsRouteImport } from "./routes/admin.analytics"
import { Route as AdminActiveUsersRouteImport } from "./routes/admin.active-users"

const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesRoute = CoursesRouteImport.update({
  id: "/courses",
  path: "/courses",
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: "/cookies",
  path: "/cookies",
  getParentRoute: () => rootRouteImport,
} as any)
const AttendanceRecordRoute = AttendanceRecordRouteImport.update({
  id: "/attendance-record",
  path: "/attendance-record",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentsRoute = AdminStudentsRouteImport.update({
  id: "/students",
  path: "/students",
  getParentRoute: () => AdminRoute,
} as any)
const AdminSchoolTypeRoute = AdminSchoolTypeRouteImport.update({
  id: "/school-type",
  path: "/school-type",
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => AdminRoute,
} as any)
const AdminPupilAttendanceRoute = AdminPupilAttendanceRouteImport.update({
  id: "/pupil-attendance",
  path: "/pupil-attendance",
  getParentRoute: () => AdminRoute,
} as any)
const AdminOnboardingRoute = AdminOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AdminRoute,
} as any)
const AdminMapRoute = AdminMapRouteImport.update({
  id: "/map",
  path: "/map",
  getParentRoute: () => AdminRoute,
} as any)
const AdminLgaRoute = AdminLgaRouteImport.update({
  id: "/lga",
  path: "/lga",
  getParentRoute: () => AdminRoute,
} as any)
const AdminFlaggedRoute = AdminFlaggedRouteImport.update({
  id: "/flagged",
  path: "/flagged",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCoursesRoute = AdminCoursesRouteImport.update({
  id: "/courses",
  path: "/courses",
  getParentRoute: () => AdminRoute,
} as any)
const AdminCalendarRoute = AdminCalendarRouteImport.update({
  id: "/calendar",
  path: "/calendar",
  getParentRoute: () => AdminRoute,
} as any)
const AdminAssistantRoute = AdminAssistantRouteImport.update({
  id: "/assistant",
  path: "/assistant",
  getParentRoute: () => AdminRoute,
} as any)
const AdminAssignRoute = AdminAssignRouteImport.update({
  id: "/assign",
  path: "/assign",
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: "/analytics",
  path: "/analytics",
  getParentRoute: () => AdminRoute,
} as any)
const AdminActiveUsersRoute = AdminActiveUsersRouteImport.update({
  id: "/active-users",
  path: "/active-users",
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteWithChildren
  "/attendance-record": typeof AttendanceRecordRoute
  "/cookies": typeof CookiesRoute
  "/courses": typeof CoursesRoute
  "/dashboard": typeof DashboardRoute
  "/login": typeof LoginRoute
  "/privacy": typeof PrivacyRoute
  "/settings": typeof SettingsRoute
  "/signup": typeof SignupRoute
  "/terms": typeof TermsRoute
  "/admin/active-users": typeof AdminActiveUsersRoute
  "/admin/analytics": typeof AdminAnalyticsRoute
  "/admin/assign": typeof AdminAssignRoute
  "/admin/assistant": typeof AdminAssistantRoute
  "/admin/calendar": typeof AdminCalendarRoute
  "/admin/courses": typeof AdminCoursesRoute
  "/admin/flagged": typeof AdminFlaggedRoute
  "/admin/lga": typeof AdminLgaRoute
  "/admin/map": typeof AdminMapRoute
  "/admin/onboarding": typeof AdminOnboardingRoute
  "/admin/pupil-attendance": typeof AdminPupilAttendanceRoute
  "/admin/reports": typeof AdminReportsRoute
  "/admin/school-type": typeof AdminSchoolTypeRoute
  "/admin/students": typeof AdminStudentsRoute
  "/admin/": typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/attendance-record": typeof AttendanceRecordRoute
  "/cookies": typeof CookiesRoute
  "/courses": typeof CoursesRoute
  "/dashboard": typeof DashboardRoute
  "/login": typeof LoginRoute
  "/privacy": typeof PrivacyRoute
  "/settings": typeof SettingsRoute
  "/signup": typeof SignupRoute
  "/terms": typeof TermsRoute
  "/admin/active-users": typeof AdminActiveUsersRoute
  "/admin/analytics": typeof AdminAnalyticsRoute
  "/admin/assign": typeof AdminAssignRoute
  "/admin/assistant": typeof AdminAssistantRoute
  "/admin/calendar": typeof AdminCalendarRoute
  "/admin/courses": typeof AdminCoursesRoute
  "/admin/flagged": typeof AdminFlaggedRoute
  "/admin/lga": typeof AdminLgaRoute
  "/admin/map": typeof AdminMapRoute
  "/admin/onboarding": typeof AdminOnboardingRoute
  "/admin/pupil-attendance": typeof AdminPupilAttendanceRoute
  "/admin/reports": typeof AdminReportsRoute
  "/admin/school-type": typeof AdminSchoolTypeRoute
  "/admin/students": typeof AdminStudentsRoute
  "/admin": typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/admin": typeof AdminRouteWithChildren
  "/attendance-record": typeof AttendanceRecordRoute
  "/cookies": typeof CookiesRoute
  "/courses": typeof CoursesRoute
  "/dashboard": typeof DashboardRoute
  "/login": typeof LoginRoute
  "/privacy": typeof PrivacyRoute
  "/settings": typeof SettingsRoute
  "/signup": typeof SignupRoute
  "/terms": typeof TermsRoute
  "/admin/active-users": typeof AdminActiveUsersRoute
  "/admin/analytics": typeof AdminAnalyticsRoute
  "/admin/assign": typeof AdminAssignRoute
  "/admin/assistant": typeof AdminAssistantRoute
  "/admin/calendar": typeof AdminCalendarRoute
  "/admin/courses": typeof AdminCoursesRoute
  "/admin/flagged": typeof AdminFlaggedRoute
  "/admin/lga": typeof AdminLgaRoute
  "/admin/map": typeof AdminMapRoute
  "/admin/onboarding": typeof AdminOnboardingRoute
  "/admin/pupil-attendance": typeof AdminPupilAttendanceRoute
  "/admin/reports": typeof AdminReportsRoute
  "/admin/school-type": typeof AdminSchoolTypeRoute
  "/admin/students": typeof AdminStudentsRoute
  "/admin/": typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/attendance-record"
    | "/cookies"
    | "/courses"
    | "/dashboard"
    | "/login"
    | "/privacy"
    | "/settings"
    | "/signup"
    | "/terms"
    | "/admin/active-users"
    | "/admin/analytics"
    | "/admin/assign"
    | "/admin/assistant"
    | "/admin/calendar"
    | "/admin/courses"
    | "/admin/flagged"
    | "/admin/lga"
    | "/admin/map"
    | "/admin/onboarding"
    | "/admin/pupil-attendance"
    | "/admin/reports"
    | "/admin/school-type"
    | "/admin/students"
    | "/admin/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/attendance-record"
    | "/cookies"
    | "/courses"
    | "/dashboard"
    | "/login"
    | "/privacy"
    | "/settings"
    | "/signup"
    | "/terms"
    | "/admin/active-users"
    | "/admin/analytics"
    | "/admin/assign"
    | "/admin/assistant"
    | "/admin/calendar"
    | "/admin/courses"
    | "/admin/flagged"
    | "/admin/lga"
    | "/admin/map"
    | "/admin/onboarding"
    | "/admin/pupil-attendance"
    | "/admin/reports"
    | "/admin/school-type"
    | "/admin/students"
    | "/admin"
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/attendance-record"
    | "/cookies"
    | "/courses"
    | "/dashboard"
    | "/login"
    | "/privacy"
    | "/settings"
    | "/signup"
    | "/terms"
    | "/admin/active-users"
    | "/admin/analytics"
    | "/admin/assign"
    | "/admin/assistant"
    | "/admin/calendar"
    | "/admin/courses"
    | "/admin/flagged"
    | "/admin/lga"
    | "/admin/map"
    | "/admin/onboarding"
    | "/admin/pupil-attendance"
    | "/admin/reports"
    | "/admin/school-type"
    | "/admin/students"
    | "/admin/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AttendanceRecordRoute: typeof AttendanceRecordRoute
  CookiesRoute: typeof CookiesRoute
  CoursesRoute: typeof CoursesRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  SettingsRoute: typeof SettingsRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/terms": {
      id: "/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signup": {
      id: "/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/dashboard": {
      id: "/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/courses": {
      id: "/courses"
      path: "/courses"
      fullPath: "/courses"
      preLoaderRoute: typeof CoursesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/cookies": {
      id: "/cookies"
      path: "/cookies"
      fullPath: "/cookies"
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/attendance-record": {
      id: "/attendance-record"
      path: "/attendance-record"
      fullPath: "/attendance-record"
      preLoaderRoute: typeof AttendanceRecordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin/": {
      id: "/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/students": {
      id: "/admin/students"
      path: "/students"
      fullPath: "/admin/students"
      preLoaderRoute: typeof AdminStudentsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/school-type": {
      id: "/admin/school-type"
      path: "/school-type"
      fullPath: "/admin/school-type"
      preLoaderRoute: typeof AdminSchoolTypeRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/reports": {
      id: "/admin/reports"
      path: "/reports"
      fullPath: "/admin/reports"
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/pupil-attendance": {
      id: "/admin/pupil-attendance"
      path: "/pupil-attendance"
      fullPath: "/admin/pupil-attendance"
      preLoaderRoute: typeof AdminPupilAttendanceRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/onboarding": {
      id: "/admin/onboarding"
      path: "/onboarding"
      fullPath: "/admin/onboarding"
      preLoaderRoute: typeof AdminOnboardingRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/map": {
      id: "/admin/map"
      path: "/map"
      fullPath: "/admin/map"
      preLoaderRoute: typeof AdminMapRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/lga": {
      id: "/admin/lga"
      path: "/lga"
      fullPath: "/admin/lga"
      preLoaderRoute: typeof AdminLgaRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/flagged": {
      id: "/admin/flagged"
      path: "/flagged"
      fullPath: "/admin/flagged"
      preLoaderRoute: typeof AdminFlaggedRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/courses": {
      id: "/admin/courses"
      path: "/courses"
      fullPath: "/admin/courses"
      preLoaderRoute: typeof AdminCoursesRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/calendar": {
      id: "/admin/calendar"
      path: "/calendar"
      fullPath: "/admin/calendar"
      preLoaderRoute: typeof AdminCalendarRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/assistant": {
      id: "/admin/assistant"
      path: "/assistant"
      fullPath: "/admin/assistant"
      preLoaderRoute: typeof AdminAssistantRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/assign": {
      id: "/admin/assign"
      path: "/assign"
      fullPath: "/admin/assign"
      preLoaderRoute: typeof AdminAssignRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/analytics": {
      id: "/admin/analytics"
      path: "/analytics"
      fullPath: "/admin/analytics"
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    "/admin/active-users": {
      id: "/admin/active-users"
      path: "/active-users"
      fullPath: "/admin/active-users"
      preLoaderRoute: typeof AdminActiveUsersRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminActiveUsersRoute: typeof AdminActiveUsersRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminAssignRoute: typeof AdminAssignRoute
  AdminAssistantRoute: typeof AdminAssistantRoute
  AdminCalendarRoute: typeof AdminCalendarRoute
  AdminCoursesRoute: typeof AdminCoursesRoute
  AdminFlaggedRoute: typeof AdminFlaggedRoute
  AdminLgaRoute: typeof AdminLgaRoute
  AdminMapRoute: typeof AdminMapRoute
  AdminOnboardingRoute: typeof AdminOnboardingRoute
  AdminPupilAttendanceRoute: typeof AdminPupilAttendanceRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSchoolTypeRoute: typeof AdminSchoolTypeRoute
  AdminStudentsRoute: typeof AdminStudentsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminActiveUsersRoute: AdminActiveUsersRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminAssignRoute: AdminAssignRoute,
  AdminAssistantRoute: AdminAssistantRoute,
  AdminCalendarRoute: AdminCalendarRoute,
  AdminCoursesRoute: AdminCoursesRoute,
  AdminFlaggedRoute: AdminFlaggedRoute,
  AdminLgaRoute: AdminLgaRoute,
  AdminMapRoute: AdminMapRoute,
  AdminOnboardingRoute: AdminOnboardingRoute,
  AdminPupilAttendanceRoute: AdminPupilAttendanceRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSchoolTypeRoute: AdminSchoolTypeRoute,
  AdminStudentsRoute: AdminStudentsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AttendanceRecordRoute: AttendanceRecordRoute,
  CookiesRoute: CookiesRoute,
  CoursesRoute: CoursesRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  SettingsRoute: SettingsRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
